import React, { useEffect, useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";

export default function Home() {
  const navigate = useNavigate();
  const [blogData, setBlogData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [latestPost, setLatestPost] = useState(null);

  // Utility to extract number from category like "Letter 1"
  const extractLetterNumber = (str) => {
    const match = str.match(/Letter\s*(\d+)/);
    return match ? parseInt(match[1], 10) : Number.MAX_SAFE_INTEGER;
  };

  useEffect(() => {
    fetch("https://tnbx7rvcbc.us-east-1.awsapprunner.com/posts")
      .then((response) => response.json())
      .then((data) => {
        setBlogData(data);
        if (data && Array.isArray(data)) {
          const latest = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          )[0];
          setLatestPost(latest);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching posts:", error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    console.log(latestPost, "latestPost");
  }, [latestPost]);

  // All unique categories sorted like "Letter 1", "Letter 2", ...
  const allCategories = [
    "All",
    ...Array.from(
      new Set(blogData.map((blog) => blog.articleCategory || "Uncategorized"))
    ).sort((a, b) => extractLetterNumber(a) - extractLetterNumber(b)),
  ];

  // Filter by selected category
  const filteredBlogs =
    selectedCategory === "All"
      ? blogData
      : blogData.filter(
        (blog) =>
          (blog.articleCategory || "Uncategorized") === selectedCategory
      );

  // Group blogs by category
  const groupedBlogs = filteredBlogs.reduce((acc, blog) => {
    const category = blog.articleCategory || "Uncategorized";
    if (!acc[category]) acc[category] = [];
    acc[category].push(blog);
    return acc;
  }, {});

  return (
    <div className="page">
      <Header />

      {/* Banner */}
      <div className="banner black">
        <img src="/blog_banner_img.jpg" alt="Banner" style={{ objectFit: "contain" }} />
        {/* <div className="content">
          <h2>
            {latestPost?.articleCategory} : {latestPost?.title}
          </h2>
          <button onClick={() => navigate(`/blog/${latestPost._id}`)}>
            Read the latest
            <span>
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-arrow-right"
              >
                <path d="M5 12h14"></path>
                <path d="m12 5 7 7-7 7"></path>
              </svg>
            </span>
          </button>
        </div> */}
      </div>

      {/* Category Menu */}
      <div className="category_menu_scroll">
        <div className="category_menu">
          {allCategories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`category_button ${selectedCategory === category ? "active" : ""
                }`}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      {/* Blog List */}
      <div className="blog_list_wrapper">
        {loading && <p>Loading articles...</p>}

        {!loading &&
          Object.entries(groupedBlogs)
            .sort(
              ([catA], [catB]) =>
                extractLetterNumber(catA) - extractLetterNumber(catB)
            )
            .map(([category, blogs]) => (
              <div key={category} className="category_section">
                <h2 className="category_title">{category}</h2>
                <div className="item_container">
                  {blogs
                    .sort(
                      (a, b) =>
                        extractLetterNumber(a.articleCategory) -
                        extractLetterNumber(b.articleCategory)
                    )
                    .map((data) => (
                      <div
                        className="blog_item"
                        key={data._id}
                        onClick={() => navigate(`/blog/${data._id}`)}
                      >
                        <div className="img">
                          <img src={data.thumbnailUrl} alt={data.title} />
                        </div>
                        <div className="content">
                          <h3>{data.title}</h3>
                          <p>{moment(data.createdAt).format("MMMM Do YYYY")}</p>
                        </div>
                      </div>
                    ))}
                  <div className="blog_item"></div>
                  <div className="blog_item"></div>
                </div>
              </div>
            ))}

      </div>
    </div>
  );
}
